import { gql } from '@utils/gpl-dedup';

export const paginatorInfoFragment = gql`
  fragment paginatorInfo on PaginatorInfo {
    count
    currentPage
    firstItem
    hasMorePages
    lastItem
    lastPage
    perPage
    total
  }
`;
